<app-document-subheader />

@let knownIpAddress = this.knownIpAddress$ | async;

<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (knownIpAddress) {
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">

                <div class="row mb-2">
                  <div class="col-12 col-md-9 mr-auto">
                    <div class="form-group">
                      <label class="form-title-label" translate
                      >KNOWN_IP_ADDRESS_LBL_ADDRESS</label
                      >
                      <div class="form-title">{{ knownIpAddress.address }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md">

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >KNOWN_IP_ADDRESS_LBL_WORK_LOCATION_NAME</label
                      >
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          @if (!!knownIpAddress.workLocationId) {
                            <app-link-to
                              [id]="knownIpAddress.workLocationId.toString()"
                              [label]="knownIpAddress.workLocationName"
                              [url]="'/Configuration/WorkLocations/Details/'"
                            />
                          } @else {
                            -
                          }
                          </span>
                      </div>
                    </div>


                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >KNOWN_IP_ADDRESS_LBL_CREATION_DATE</label
                      >
                      <div class="col">
                        <span
                          class="form-control-plaintext form-control-sm">
                          {{ knownIpAddress.creationDate | date : "dd/MM/yyyy" }}
                        </span>
                      </div>
                    </div>

                  </div>
                  <div class="col">

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >KNOWN_IP_ADDRESS_LBL_WORK_LOCATION_TYPE</label
                      >
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm h-100">
                            @if (!!knownIpAddress.workLocationTypeLoc) {
                              {{ knownIpAddress.workLocationTypeLoc }}
                            } @else {
                              -
                            }
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (knownIpAddress) {
      <div class="col-comment">
        <app-comment-panel
          [entityType]="'KnownIpAddress'"
          [entityId]="knownIpAddress.id.toString()"
        ></app-comment-panel>
      </div>
    }
  </div>
</div>
